<template>
  <form @submit.prevent="$emit('submit')" class="white-box p30">
    <div class="row">
      <div class="col-sm-6">
        <FieldTextInput name="Distribute to" rules="required" v-model="value.distribute_to" :disabled="true" />
      </div>
      <div class="col-sm-6">
        <FieldDate name="Date" rules="required" v-model="value.date" :disabled="disabled" />
      </div>
      <div class="col-sm-12">
        <FieldTextArea name="Description" rules="required" v-model="value.description" :disabled="disabled" />
      </div>
      <div class="col-sm-12">
        <FieldTextArea name="Preventive Action" rules="required" v-model="value.preventive_action" :disabled="disabled" />
      </div>
      <div class="col-sm-12">
        <FieldTextArea name="Corrective Action" rules="required" v-model="value.corrective_action" :disabled="disabled" />
      </div>
      <div class="col-sm-6">
         <FieldMedia name="Photo" rules="required" type="image" :multiple="true" :maxFiles="5"
          :maxFileSize="5 * 1024 * 1024" v-model="value.photos" :disabled="disabled" />
      </div>
      <div class="col-sm-12">
        <div class="separator dashed"></div>
      </div>
      <div class="col-sm-6">
        <FieldTextInput name="Prepared by" rules="required" v-model="value.prepared_by" :disabled="true" />
      </div>
    </div>
    <div v-if="!disabled" class="d-flex justify-content-center">
      <button class="btn btn-orange" type="submit">Save</button>
    </div>
  </form>
</template>
<script>
import FieldDate from '@/components/field/Date.vue';
import FieldMedia from '@/components/field/Media.vue';
import FieldTextInput from '@/components/field/TextInput.vue';
import FieldTextArea from '@/components/field/TextArea.vue';

export default {
  name: "FormFeedbackCustomerIssue",
  components: {
    FieldTextInput,
    FieldDate,
    FieldMedia,
    FieldTextArea
  },
  props: ['value', 'disabled'],
}
</script>
